/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Writing to Local Storage - Browser Storage
/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const useGetLocalStorage = (value: string) => {
  if (import.meta.client) {
    return localStorage.getItem(value)
  }
  return
}

export const useSetLocalStorage = (key: string, value: string) => {
  if (import.meta.client) {
    localStorage.setItem(key, value)
    return { key, value }
  }
  return
}

export const useRemoveLocalStorage = (key: string, value: string) => {
  if (import.meta.client) {
    localStorage.removeItem(key)
    return { key }
  }
  return
}